/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Rueckkauf } from './rueckkauf';
import { PoliceRoleEntity } from './policeRoleEntity';
import { Partner } from './partner';
import { Fond } from './fond';
import { AccountInformation } from './accountInformation';
import { UpdatePolice } from './updatePolice';


export interface PoliceEntity { 
    policennummer: string;
    partner?: Partner;
    partnernummer: string;
    produktDe: string;
    produktFr: string;
    produktIt: string;
    vorsorgeart: PoliceEntity.VorsorgeartEnum;
    vertragsbeginn: string;
    vertragsablauf: string;
    technischesAblaufdatum: string;
    waehrung: PoliceEntity.WaehrungEnum;
    erlebensfallsumme: number;
    todesfallsumme: number;
    erwerbsunfaehigkeitsrente: number;
    leibrente: number;
    technischerZins: number;
    beguenstigungErlebensfall: PoliceEntity.BeguenstigungErlebensfallEnum;
    beguenstigungTodesfall: PoliceEntity.BeguenstigungTodesfallEnum;
    ratenpraemie: number;
    zahlungsart: PoliceEntity.ZahlungsartEnum;
    jahrespraemie: number;
    einmalpraemie: number;
    inkassoart: PoliceEntity.InkassoartEnum;
    inkassoartEsrVersand: boolean;
    korrespondenzadresseVorhanden: boolean;
    mitarbeiterPolice: boolean;
    policenstatus: PoliceEntity.PolicenstatusEnum;
    visibleUntil: string;
    lastSynchronized: string;
    changedescription: UpdatePolice;
    kontoInformationen: Array<AccountInformation>;
    rueckkauf?: Rueckkauf;
    fonds: Array<Fond>;
    stichmonat: string;
    beguenstigungTodUnwiderruflich: boolean;
    vnVtUneinheitlich: boolean;
    beguenstigungTodesfallText: string;
    jahrespraemieErhoehungErlaubt: boolean;
    isRisiko: boolean;
    isTerzaFlex: boolean;
    isPaxExtra: boolean;
    isLeibRente: boolean;
    isDiamondLife: boolean;
    isFondspolice: boolean;
    vnPzUneinheitlich: boolean;
    haupttarifnummer: string;
    policeRolesEntity: Array<PoliceRoleEntity>;
}
export namespace PoliceEntity {
    export type VorsorgeartEnum = 'F' | 'G' | 'V';
    export const VorsorgeartEnum = {
        F: 'F' as VorsorgeartEnum,
        G: 'G' as VorsorgeartEnum,
        V: 'V' as VorsorgeartEnum
    };
    export type WaehrungEnum = 'CHF' | 'EUR' | 'USD';
    export const WaehrungEnum = {
        CHF: 'CHF' as WaehrungEnum,
        EUR: 'EUR' as WaehrungEnum,
        USD: 'USD' as WaehrungEnum
    };
    export type BeguenstigungErlebensfallEnum = '1' | '2' | '3' | '4';
    export const BeguenstigungErlebensfallEnum = {
        _1: '1' as BeguenstigungErlebensfallEnum,
        _2: '2' as BeguenstigungErlebensfallEnum,
        _3: '3' as BeguenstigungErlebensfallEnum,
        _4: '4' as BeguenstigungErlebensfallEnum
    };
    export type BeguenstigungTodesfallEnum = '1' | '2' | '3' | '4';
    export const BeguenstigungTodesfallEnum = {
        _1: '1' as BeguenstigungTodesfallEnum,
        _2: '2' as BeguenstigungTodesfallEnum,
        _3: '3' as BeguenstigungTodesfallEnum,
        _4: '4' as BeguenstigungTodesfallEnum
    };
    export type ZahlungsartEnum = '00' | '01' | '02' | '04' | '12';
    export const ZahlungsartEnum = {
        _00: '00' as ZahlungsartEnum,
        _01: '01' as ZahlungsartEnum,
        _02: '02' as ZahlungsartEnum,
        _04: '04' as ZahlungsartEnum,
        _12: '12' as ZahlungsartEnum
    };
    export type InkassoartEnum = '0' | '1' | '2' | '4' | '5' | '6';
    export const InkassoartEnum = {
        _0: '0' as InkassoartEnum,
        _1: '1' as InkassoartEnum,
        _2: '2' as InkassoartEnum,
        _4: '4' as InkassoartEnum,
        _5: '5' as InkassoartEnum,
        _6: '6' as InkassoartEnum
    };
    export type PolicenstatusEnum = 'A' | 'D' | 'J' | 'K' | 'N' | 'S' | 'T' | 'X' | 'Y' | 'Z';
    export const PolicenstatusEnum = {
        A: 'A' as PolicenstatusEnum,
        D: 'D' as PolicenstatusEnum,
        J: 'J' as PolicenstatusEnum,
        K: 'K' as PolicenstatusEnum,
        N: 'N' as PolicenstatusEnum,
        S: 'S' as PolicenstatusEnum,
        T: 'T' as PolicenstatusEnum,
        X: 'X' as PolicenstatusEnum,
        Y: 'Y' as PolicenstatusEnum,
        Z: 'Z' as PolicenstatusEnum
    };
}


